import type { TranslateDictionary } from './en.js';

export const Mk: TranslateDictionary = {
  'Start airplay': 'Започни AirPlay',
  'Stop airplay': 'Запри AirPlay',
  Audio: 'Аудио',
  Captions: 'Поднаписи',
  'Enable captions': 'Овозможи поднаписи',
  'Disable captions': 'Оневозможи поднаписи',
  'Start casting': 'Започни пренос',
  'Stop casting': 'Запри пренос',
  'Casting to {device}': 'Емитување на {device}',
  'Enter fullscreen mode': 'Вклучи приказ на цел екран',
  'Exit fullscreen mode': 'Исклучи приказ на цел екран',
  Mute: 'Исклучи звук',
  Unmute: 'Вклучи звук',
  'Enter picture in picture mode': 'Вклучи режим слика-во-слика',
  'Exit picture in picture mode': 'Исклучи режим слика-во-слика',
  Play: 'Пушти',
  Pause: 'Паузирај',
  'Playback rate': 'Брзина на репродукција',
  'Playback rate {playbackRate}': 'Брзина на репродукција {playbackRate}',
  Quality: 'Квалитет',
  'Seek backward': 'Назад',
  'Seek forward': 'Напред',
  Settings: 'Поставки',
  Auto: 'Автоматски',
  'audio player': 'аудио плеер',
  'video player': 'видео плеер',
  volume: 'Јачина на звук',
  seek: 'Барај',
  'closed captions': 'Поднаписи',
  'current playback rate': 'моментална брзина на репродукција',
  'playback time': 'време на репродукција',
  'media loading': 'вчитување медиуми',
  settings: 'Поставки',
  'audio tracks': 'аудио траки',
  quality: 'Квалитет',
  play: 'пушти',
  pause: 'паузирај',
  mute: 'исклучи звук',
  unmute: 'вклучи звук',
  'chapter: {chapterName}': 'поглавје: {chapterName}',
  live: 'во живо',
  Off: 'Исклучено',
  'start airplay': 'започни AirPlay',
  'stop airplay': 'запри AirPlay',
  'start casting': 'започни пренос',
  'stop casting': 'запри пренос',
  'enter fullscreen mode': 'вклучи приказ на цел екран',
  'exit fullscreen mode': 'исклучи приказ на цел екран',
  'enter picture in picture mode': 'вклучи режим слика-во-слика',
  'exit picture in picture mode': 'исклучи режим слика-во-слика',
  'seek to live': 'оди на во живо',
  'playing live': 'пуштање во живо',
  'seek back {seekOffset} seconds': 'назад {seekOffset} секунди',
  'seek forward {seekOffset} seconds': 'напред {seekOffset} секунди',
  'Network Error': 'Мрежна грешка',
  'Decode Error': 'Грешка при декодирање',
  'Source Not Supported': 'Изворот не е поддржан',
  'Encryption Error': 'Грешка при енкрипција',
  'A network error caused the media download to fail.':
    'Мрежната грешка предизвика неуспех во преземањето на медиумот.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Грешка во медиумот предизвика прекин на репродукцијата. Медиумот може да е оштетен или вашиот прелистувач не го поддржува овој формат.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Се случи неподдржана грешка. Серверот или мрежата не успеаја, или вашиот прелистувач не го поддржува овој формат.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Медиумот е енкриптиран и нема клучеви за декрипција.',
  'This video is not available.': 'Ова видео не е достапно.',
  'This video could not be found.': 'Ова видео не е пронајдено.',
};
